export const MATERIAL_DISPOSITION_ROOT_URL = '/material_disposition';
export const MATERIAL_DISPOSITION_WHERE_USED_URL = `${MATERIAL_DISPOSITION_ROOT_URL}/lot/where_used`;
export const MATERIAL_DISPOSITION_ALL_DOCS_LIST = `${MATERIAL_DISPOSITION_ROOT_URL}/search`;
